export const charactersList = [
  {
    id: "mistveil",
    name: "雾泽",
    title: "静水之刃",
    element: "hydro",
    elementName: "水",
    role: "dps",
    roleName: "主输出",
    rarity: 5,
    weapon: "单手剑",
    region: "枫丹",
    avatar: "https://readdy.ai/api/search-image?query=anime%20style%20elegant%20female%20swordswoman%20portrait%20with%20flowing%20teal%20hair%20and%20calm%20expression%2C%20soft%20blue%20background%20with%20water%20motifs%2C%20clean%20character%20art%2C%20painterly%20fantasy%20style&width=500&height=500&seq=char-avatar-mistveil&orientation=squarish",
    splash: "https://readdy.ai/api/search-image?query=anime%20style%20full%20body%20elegant%20female%20swordswoman%20in%20flowing%20teal%20robes%20holding%20a%20water%20sword%2C%20dynamic%20pose%20with%20water%20ribbons%2C%20muted%20blue%20gradient%20background%2C%20detailed%20character%20illustration%2C%20painterly%20fantasy%20style&width=900&height=1200&seq=char-splash-mistveil&orientation=portrait",
    intro: "枫丹庭的静水守卫，以水元素凝聚剑刃的决斗家。普攻与元素战技衔接紧密，适合作为队伍核心输出。",
    popularity: 98,
    releaseDate: "2026-10-11",
    stats: {
      "基础生命": "12,860",
      "基础攻击": "342",
      "基础防御": "784",
      "最佳武器": "雾切之回光",
      "核心命座": "一命 / 四命",
    },
    talents: [
      { name: "普通攻击·静水流形", type: "普通攻击", desc: "进行至多五段的连续剑击，重击消耗体力并造成范围水元素伤害。" },
      { name: "元素战技·潮汐回响", type: "元素战技", desc: "召唤水影向前突进，造成水元素伤害并留下持续造成伤害的水域，冷却 9 秒。" },
      { name: "元素爆发·万流归一", type: "元素爆发", desc: "汇聚周围水流形成巨大剑刃，造成大范围水元素伤害，并根据队伍生命值提高倍率。" },
      { name: "固有天赋·静水之美", type: "固有天赋", desc: "队伍中每存在一名水元素角色，自身暴击伤害提升 8%。" },
    ],
    teamComp: ["雾泽 + 云堇 + 申鹤 + 万叶", "雾泽 + 夜兰 + 纳西妲 + 钟离"],
    playTips: [
      "优先保证元素充能在 130% 以上，确保元素爆发循环顺畅。",
      "元素战技带位移，可用于躲避关键机制伤害。",
      "站场输出时注意水影位置，尽量让敌人处于水域内以提高输出效率。",
    ],
  },
  {
    id: "emberlight",
    name: "烬珞",
    title: "燎原之火",
    element: "pyro",
    elementName: "火",
    role: "dps",
    roleName: "主输出",
    rarity: 5,
    weapon: "法器",
    region: "纳塔",
    avatar: "https://readdy.ai/api/search-image?query=anime%20style%20confident%20male%20mage%20portrait%20with%20crimson%20hair%20and%20glowing%20amber%20eyes%2C%20warm%20orange%20background%20with%20ember%20particles%2C%20clean%20character%20art%2C%20painterly%20fantasy%20style&width=500&height=500&seq=char-avatar-emberlight&orientation=squarish",
    splash: "https://readdy.ai/api/search-image?query=anime%20style%20full%20body%20male%20fire%20mage%20casting%20flames%20from%20an%20ornate%20tome%2C%20dynamic%20pose%20with%20ember%20sparks%2C%20warm%20dark%20gradient%20background%2C%20detailed%20character%20illustration%2C%20painterly%20fantasy%20style&width=900&height=1200&seq=char-splash-emberlight&orientation=portrait",
    intro: "来自纳塔的烈焰术士，擅长以持续灼烧压制敌人，单体爆发与群体清怪兼顾。",
    popularity: 95,
    releaseDate: "2026-09-27",
    stats: {
      "基础生命": "10,540",
      "基础攻击": "332",
      "基础防御": "620",
      "最佳武器": "神乐之真意",
      "核心命座": "二命 / 六命",
    },
    talents: [
      { name: "普通攻击·余烬", type: "普通攻击", desc: "发射至多三枚火弹，重击投掷火球造成范围火元素伤害。" },
      { name: "元素战技·焚心焰", type: "元素战技", desc: "在目标身下点燃火种，持续造成火元素伤害并降低其火元素抗性，冷却 12 秒。" },
      { name: "元素爆发·烈焰燎原", type: "元素爆发", desc: "召唤火环围绕自身，持续对范围内敌人造成火元素伤害，持续 12 秒。" },
      { name: "固有天赋·不熄之志", type: "固有天赋", desc: "触发火元素反应时，火元素伤害加成提升 15%，持续 8 秒。" },
    ],
    teamComp: ["烬珞 + 班尼特 + 香菱 + 万叶", "烬珞 + 迪希雅 + 莫娜 + 钟离"],
    playTips: [
      "元素战技的减抗效果需要先手释放，再开启爆发收益更高。",
      "搭配班尼特可大幅提升攻击力面板，是主流绑定组合。",
      "重击耗体力较多，建议在体力充足时使用。",
    ],
  },
  {
    id: "galeheart",
    name: "岚心",
    title: "御风之翼",
    element: "anemo",
    elementName: "风",
    role: "support",
    roleName: "辅助",
    rarity: 5,
    weapon: "弓",
    region: "蒙德",
    avatar: "https://readdy.ai/api/search-image?query=anime%20style%20gentle%20female%20archer%20portrait%20with%20light%20green%20hair%20and%20feather%20accessory%2C%20fresh%20mint%20background%20with%20swirling%20wind%20motifs%2C%20clean%20character%20art%2C%20painterly%20fantasy%20style&width=500&height=500&seq=char-avatar-galeheart&orientation=squarish",
    splash: "https://readdy.ai/api/search-image?query=anime%20style%20full%20body%20female%20archer%20drawing%20a%20glowing%20bow%20amidswirling%20wind%20currents%2C%20dynamic%20pose%2C%20soft%20green%20gradient%20background%2C%20detailed%20character%20illustration%2C%20painterly%20fantasy%20style&width=900&height=1200&seq=char-splash-galeheart&orientation=portrait",
    intro: "蒙德的御风射手，能为队伍提供聚怪与减抗，是许多阵容中不可替代的辅助核心。",
    popularity: 92,
    releaseDate: "2026-08-20",
    stats: {
      "基础生命": "10,890",
      "基础攻击": "283",
      "基础防御": "654",
      "最佳武器": "若水",
      "核心命座": "一命 / 六命",
    },
    talents: [
      { name: "普通攻击·风行", type: "普通攻击", desc: "进行至多四段的射击，瞄准射击蓄力后附带风元素伤害。" },
      { name: "元素战技·引风之矢", type: "元素战技", desc: "射出箭矢将敌人吸引至落点，造成风元素伤害，冷却 9 秒。" },
      { name: "元素爆发·轻风颂歌", type: "元素爆发", desc: "创造持续吸引敌人的风场，并周期性造成风元素伤害，持续 8 秒。" },
      { name: "固有天赋·御风之姿", type: "固有天赋", desc: "处于风场中的队伍角色移动速度提升，受到的伤害降低 10%。" },
    ],
    teamComp: ["岚心 + 任意主输出 + 双辅助", "岚心 + 烬珞 + 班尼特 + 钟离"],
    playTips: [
      "元素爆发的聚怪范围较大，可先手聚怪再切换主 C。",
      "元素战技位移可用来快速接近或拉开距离。",
      "减抗效果依赖风套，记得给辅助携带翠绿之影。",
    ],
  },
  {
    id: "stonebulwark",
    name: "磐岩",
    title: "不屈之石",
    element: "geo",
    elementName: "岩",
    role: "defense",
    roleName: "防御",
    rarity: 5,
    weapon: "单手剑",
    region: "璃月",
    avatar: "https://readdy.ai/api/search-image?query=anime%20style%20stoic%20male%20warrior%20portrait%20with%20dark%20hair%20and%20amber%20armor%20details%2C%20warm%20stone%20colored%20background%20with%20geometric%20motifs%2C%20clean%20character%20art%2C%20painterly%20fantasy%20style&width=500&height=500&seq=char-avatar-stonebulwark&orientation=squarish",
    splash: "https://readdy.ai/api/search-image?query=anime%20style%20full%20body%20male%20warrior%20raising%20a%20glowing%20stone%20barrier%2C%20grounded%20stance%2C%20warm%20ochre%20gradient%20background%2C%20detailed%20character%20illustration%2C%20painterly%20fantasy%20style&width=900&height=1200&seq=char-splash-stonebulwark&orientation=portrait",
    intro: "璃月的磐石守卫，以坚固护盾保护队友并反击敌人，是队伍的稳定防线。",
    popularity: 88,
    releaseDate: "2026-07-15",
    stats: {
      "基础生命": "14,680",
      "基础攻击": "251",
      "基础防御": "1010",
      "最佳武器": "祭礼剑",
      "核心命座": "二命 / 四命",
    },
    talents: [
      { name: "普通攻击·岩击", type: "普通攻击", desc: "进行至多四段的连续斩击，重击消耗体力造成岩元素伤害。" },
      { name: "元素战技·磐石壁垒", type: "元素战技", desc: "生成可吸收伤害的岩元素护盾，护盾存在时角色抗打断能力提升，冷却 12 秒。" },
      { name: "元素爆发·山岳回响", type: "元素爆发", desc: "引发地脉震动，对周围敌人造成大量岩元素伤害并生成屏障。" },
      { name: "固有天赋·不动如山", type: "固有天赋", desc: "护盾存在时，队伍角色受到的伤害降低 15%。" },
    ],
    teamComp: ["磐岩 + 雾泽 + 岚心 + 班尼特", "磐岩 + 烬珞 + 香菱 + 万叶"],
    playTips: [
      "护盾生命值收益极高，优先堆生命值属性。",
      "护盾存在期间抗打断，适合应对高频率攻击的敌人。",
      "岩元素护盾对全属性有额外吸收效果，泛用性很强。",
    ],
  },
  {
    id: "frostbloom",
    name: "霜花序",
    title: "极寒绽放",
    element: "cryo",
    elementName: "冰",
    role: "support",
    roleName: "辅助",
    rarity: 5,
    weapon: "弓",
    region: "至冬",
    avatar: "https://readdy.ai/api/search-image?query=anime%20style%20cool%20female%20archer%20portrait%20with%20pale%20blue%20hair%20and%20ice%20crystal%20earrings%2C%20icy%20light%20background%20with%20frost%20motifs%2C%20clean%20character%20art%2C%20painterly%20fantasy%20style&width=500&height=500&seq=char-avatar-frostbloom&orientation=squarish",
    splash: "https://readdy.ai/api/search-image?query=anime%20style%20full%20body%20female%20archer%20conjuring%20ice%20crystals%20around%20a%20frozen%20arrow%2C%20elegant%20pose%2C%20cold%20pale%20blue%20gradient%20background%2C%20detailed%20character%20illustration%2C%20painterly%20fantasy%20style&width=900&height=1200&seq=char-splash-frostbloom&orientation=portrait",
    intro: "来自至冬的冰晶射手，能为队伍提供冰元素附着与暴击率增益，是冻结流派的核心。",
    popularity: 90,
    releaseDate: "2026-06-30",
    stats: {
      "基础生命": "10,120",
      "基础攻击": "305",
      "基础防御": "601",
      "最佳武器": "终末嗟叹之诗",
      "核心命座": "一命 / 二命",
    },
    talents: [
      { name: "普通攻击·霜羽", type: "普通攻击", desc: "进行至多四段射击，瞄准射击蓄力造成冰元素伤害。" },
      { name: "元素战技·冰晶花", type: "元素战技", desc: "在目标位置绽放冰晶，造成冰元素伤害并为队伍提供护盾，冷却 10 秒。" },
      { name: "元素爆发·极寒风暴", type: "元素爆发", desc: "召唤暴风雪持续造成冰元素伤害，持续 10 秒。" },
      { name: "固有天赋·冰川回响", type: "固有天赋", desc: "触发冰元素反应时，队伍暴击率提升 12%，持续 10 秒。" },
    ],
    teamComp: ["霜花序 + 雾泽 + 万叶 + 钟离", "霜花序 + 任意冰主 C + 双辅助"],
    playTips: [
      "暴击率增益持续较长，可在开局时先手释放。",
      "冰盾与护盾角色可以叠加使用，提升生存能力。",
      "与冻结流派配合时，注意敌人韧性与状态抗性。",
    ],
  },
  {
    id: "stormcaller",
    name: "雷鸣",
    title: "雷霆御者",
    element: "electro",
    elementName: "雷",
    role: "dps",
    roleName: "主输出",
    rarity: 5,
    weapon: "长柄武器",
    region: "稻妻",
    avatar: "https://readdy.ai/api/search-image?query=anime%20style%20determined%20female%20spear%20wielder%20portrait%20with%20purple%20streaked%20hair%20and%20glowing%20eyes%2C%20deep%20violet%20background%20with%20lightning%20motifs%2C%20clean%20character%20art%2C%20painterly%20fantasy%20style&width=500&height=500&seq=char-avatar-stormcaller&orientation=squarish",
    splash: "https://readdy.ai/api/search-image?query=anime%20style%20full%20body%20female%20spear%20wielder%20surrounded%20by%20crackling%20lightning%2C%20dynamic%20pose%2C%20deep%20violet%20gradient%20background%2C%20detailed%20character%20illustration%2C%20painterly%20fantasy%20style&width=900&height=1200&seq=char-splash-stormcaller&orientation=portrait",
    intro: "稻妻的雷霆御者，以高速普攻与雷元素附魔见长，爆发期输出极为可观。",
    popularity: 94,
    releaseDate: "2026-05-18",
    stats: {
      "基础生命": "12,130",
      "基础攻击": "337",
      "基础防御": "695",
      "最佳武器": "薙草之稻光",
      "核心命座": "二命 / 六命",
    },
    talents: [
      { name: "普通攻击·雷闪", type: "普通攻击", desc: "进行至多五段的连击，重击消耗体力造成范围雷元素伤害。" },
      { name: "元素战技·雷印", type: "元素战技", desc: "对目标施加雷印，提升队伍元素爆发伤害，冷却 10 秒。" },
      { name: "元素爆发·雷霆万钧", type: "元素爆发", desc: "进入雷附魔状态，普攻造成雷元素伤害并回复元素能量，持续 7 秒。" },
      { name: "固有天赋·雷御之姿", type: "固有天赋", desc: "元素爆发期间，普攻命中敌人时元素充能效率提升 30%。" },
    ],
    teamComp: ["雷鸣 + 班尼特 + 香菱 + 万叶", "雷鸣 + 夜兰 + 钟离 + 枫原万叶"],
    playTips: [
      "元素充能是核心属性，建议堆到 200% 以上以保证循环。",
      "元素战技提供的增伤对全队元素爆发生效，先手释放收益更高。",
      "站场时间较长，注意躲避高伤害机制。",
    ],
  },
  {
    id: "seafoam",
    name: "蒹葭",
    title: "沧浪之歌",
    element: "hydro",
    elementName: "水",
    role: "support",
    roleName: "辅助",
    rarity: 4,
    weapon: "法器",
    region: "枫丹",
    avatar: "https://readdy.ai/api/search-image?query=anime%20style%20cheerful%20female%20mage%20portrait%20with%20wavy%20blue%20hair%20and%20shell%20accessory%2C%20soft%20aqua%20background%20with%20bubble%20motifs%2C%20clean%20character%20art%2C%20painterly%20fantasy%20style&width=500&height=500&seq=char-avatar-seafoam&orientation=squarish",
    splash: "https://readdy.ai/api/search-image?query=anime%20style%20full%20body%20female%20water%20mage%20summoning%20a%20spiral%20of%20bubbles%2C%20playful%20pose%2C%20soft%20aqua%20gradient%20background%2C%20detailed%20character%20illustration%2C%20painterly%20fantasy%20style&width=900&height=1200&seq=char-splash-seafoam&orientation=portrait",
    intro: "枫丹的海洋学者，能以水泡为队伍提供治疗与增伤，是性价比极高的四星辅助。",
    popularity: 85,
    releaseDate: "2026-04-12",
    stats: {
      "基础生命": "11,540",
      "基础攻击": "222",
      "基础防御": "640",
      "最佳武器": "讨龙英杰谭",
      "核心命座": "二命 / 五命",
    },
    talents: [
      { name: "普通攻击·水泡", type: "普通攻击", desc: "发射水泡，重击造成范围水元素伤害。" },
      { name: "元素战技·潮汐之拥", type: "元素战技", desc: "为场上的角色施加水元素护盾并持续治疗，冷却 12 秒。" },
      { name: "元素爆发·沧浪之歌", type: "元素爆发", desc: "为全队提供治疗并根据生命值上限提升攻击力，持续 15 秒。" },
      { name: "固有天赋·海之馈赠", type: "固有天赋", desc: "为队伍提供治疗时，队伍元素充能效率提升 10%。" },
    ],
    teamComp: ["蒹葭 + 雾泽 + 岚心 + 磐岩", "蒹葭 + 任意主输出 + 双辅助"],
    playTips: [
      "堆生命值即可兼顾护盾与治疗，养成成本低。",
      "元素爆发提供的攻击力增益对全队生效，适合速切阵容。",
      "适合作为新手的泛用辅助角色培养。",
    ],
  },
  {
    id: "flameforge",
    name: "熔铸",
    title: "匠火之心",
    element: "pyro",
    elementName: "火",
    role: "support",
    roleName: "辅助",
    rarity: 4,
    weapon: "单手剑",
    region: "纳塔",
    avatar: "https://readdy.ai/api/search-image?query=anime%20style%20sturdy%20male%20blacksmith%20portrait%20with%20orange%20hair%20and%20soot%20marks%2C%20warm%20forge%20background%20with%20ember%20motifs%2C%20clean%20character%20art%2C%20painterly%20fantasy%20style&width=500&height=500&seq=char-avatar-flameforge&orientation=squarish",
    splash: "https://readdy.ai/api/search-image?query=anime%20style%20full%20body%20male%20blacksmith%20wielding%20a%20flaming%20hammer%20and%20sword%2C%20strong%20stance%2C%20warm%20orange%20gradient%20background%2C%20detailed%20character%20illustration%2C%20painterly%20fantasy%20style&width=900&height=1200&seq=char-splash-flameforge&orientation=portrait",
    intro: "纳塔的锻造大师，能为队伍提供火元素附魔与攻击力增益，是优秀的四星火系辅助。",
    popularity: 82,
    releaseDate: "2026-03-22",
    stats: {
      "基础生命": "12,900",
      "基础攻击": "234",
      "基础防御": "700",
      "最佳武器": "匣里灭辰",
      "核心命座": "四命 / 六命",
    },
    talents: [
      { name: "普通攻击·火花", type: "普通攻击", desc: "进行至多四段连续斩击，重击造成火元素伤害。" },
      { name: "元素战技·熔炉之心", type: "元素战技", desc: "为队伍角色提供火元素附魔并为武器附加强化效果，冷却 15 秒。" },
      { name: "元素爆发·锻造盛典", type: "元素爆发", desc: "为全队提升攻击力并为自身附加火元素护盾，持续 12 秒。" },
      { name: "固有天赋·匠人之魂", type: "固有天赋", desc: "队伍中每有一名双手剑角色，全队防御力提升 8%。" },
    ],
    teamComp: ["熔铸 + 烬珞 + 香菱 + 万叶", "熔铸 + 雷鸣 + 班尼特 + 钟离"],
    playTips: [
      "附魔效果对双手剑以外的近战武器同样生效，泛用性强。",
      "防御增益与护盾角色搭配效果更佳。",
      "适合作为火系队伍的第四人补位。",
    ],
  },
  {
    id: "thornvine",
    name: "荆藤",
    title: "森之守卫",
    element: "dendro",
    elementName: "草",
    role: "support",
    roleName: "辅助",
    rarity: 5,
    weapon: "法器",
    region: "须弥",
    avatar: "https://readdy.ai/api/search-image?query=anime%20style%20serene%20female%20scholar%20portrait%20with%20green%20braided%20hair%20and%20leaf%20crown%2C%20soft%20green%20background%20with%20vine%20motifs%2C%20clean%20character%20art%2C%20painterly%20fantasy%20style&width=500&height=500&seq=char-avatar-thornvine&orientation=squarish",
    splash: "https://readdy.ai/api/search-image?query=anime%20style%20full%20body%20female%20dendro%20scholar%20commanding%20vines%20from%20the%20ground%2C%20graceful%20pose%2C%20soft%20green%20gradient%20background%2C%20detailed%20character%20illustration%2C%20painterly%20fantasy%20style&width=900&height=1200&seq=char-splash-thornvine&orientation=portrait",
    intro: "须弥的森林学者，擅长以草元素种子触发元素反应，是激化与绽放流派的关键角色。",
    popularity: 91,
    releaseDate: "2026-02-14",
    stats: {
      "基础生命": "10,680",
      "基础攻击": "298",
      "基础防御": "628",
      "最佳武器": "千夜浮梦",
      "核心命座": "二命 / 六命",
    },
    talents: [
      { name: "普通攻击·藤蔓", type: "普通攻击", desc: "召唤藤蔓进行攻击，重击造成范围草元素伤害。" },
      { name: "元素战技·森之环", type: "元素战技", desc: "在场上生成草元素光环，为队伍提供精通加成，冷却 11 秒。" },
      { name: "元素爆发·万木生长", type: "元素爆发", desc: "召唤巨树对范围内敌人持续造成草元素伤害并生成种子。" },
      { name: "固有天赋·生机", type: "固有天赋", desc: "队伍元素精通提升 50 点，触发草元素反应时额外提升 30 点，持续 8 秒。" },
    ],
    teamComp: ["荆藤 + 雷鸣 + 蒹葭 + 万叶", "荆藤 + 烬珞 + 班尼特 + 钟离"],
    playTips: [
      "元素精通是核心属性，优先堆叠以提升反应伤害。",
      "种子生成依赖元素附着频率，注意队伍元素搭配。",
      "适合与雷、火元素角色组成激化或燃烧队伍。",
    ],
  },
  {
    id: "nightwatch",
    name: "夜巡",
    title: "暗影猎手",
    element: "electro",
    elementName: "雷",
    role: "dps",
    roleName: "副输出",
    rarity: 4,
    weapon: "单手剑",
    region: "蒙德",
    avatar: "https://readdy.ai/api/search-image?query=anime%20style%20mysterious%20male%20rogue%20portrait%20with%20dark%20hair%20and%20violet%20eyes%2C%20dark%20blue%20background%20with%20spark%20motifs%2C%20clean%20character%20art%2C%20painterly%20fantasy%20style&width=500&height=500&seq=char-avatar-nightwatch&orientation=squarish",
    splash: "https://readdy.ai/api/search-image?query=anime%20style%20full%20body%20male%20rogue%20dashing%20forward%20with%20lightning%20trails%2C%20dynamic%20low%20stance%2C%20dark%20violet%20gradient%20background%2C%20detailed%20character%20illustration%2C%20painterly%20fantasy%20style&width=900&height=1200&seq=char-splash-nightwatch&orientation=portrait",
    intro: "蒙德的暗影猎手，能够快速切换输出与脱离，是机动性极强的副输出角色。",
    popularity: 80,
    releaseDate: "2026-01-20",
    stats: {
      "基础生命": "10,240",
      "基础攻击": "258",
      "基础防御": "601",
      "最佳武器": "铁蜂刺",
      "核心命座": "一命 / 六命",
    },
    talents: [
      { name: "普通攻击·影袭", type: "普通攻击", desc: "进行至多四段的快速斩击，重击造成雷元素伤害。" },
      { name: "元素战技·瞬影", type: "元素战技", desc: "向前突进并对路径上的敌人造成雷元素伤害，冷却 8 秒。" },
      { name: "元素爆发·暗夜猎杀", type: "元素爆发", desc: "进入潜行状态，普攻附带雷元素伤害并提高移动速度。" },
      { name: "固有天赋·影之步", type: "固有天赋", desc: "元素战技命中敌人时，元素爆发冷却时间减少 1 秒。" },
    ],
    teamComp: ["夜巡 + 雷鸣 + 荆藤 + 钟离", "夜巡 + 雾泽 + 万叶 + 班尼特"],
    playTips: [
      "元素战技位移可用于躲避机制或快速接近敌人。",
      "适合作为速切副输出，与主 C 交替登场。",
      "元素充能效率建议堆到 150% 以上以保证循环。",
    ],
  },
  {
    id: "sandscribe",
    name: "砂卷",
    title: "流沙术士",
    element: "geo",
    elementName: "岩",
    role: "dps",
    roleName: "主输出",
    rarity: 5,
    weapon: "法器",
    region: "须弥",
    avatar: "https://readdy.ai/api/search-image?query=anime%20style%20male%20desert%20mage%20portrait%20with%20sand%20colored%20hair%20and%20glowing%20tattoos%2C%20warm%20tan%20background%20with%20sand%20swirl%20motifs%2C%20clean%20character%20art%2C%20painterly%20fantasy%20style&width=500&height=500&seq=char-avatar-sandscribe&orientation=squarish",
    splash: "https://readdy.ai/api/search-image?query=anime%20style%20full%20body%20desert%20mage%20summoning%20a%20swirling%20sand%20pillar%2C%20commanding%20pose%2C%20warm%20tan%20gradient%20background%2C%20detailed%20character%20illustration%2C%20painterly%20fantasy%20style&width=900&height=1200&seq=char-splash-sandscribe&orientation=portrait",
    intro: "须弥沙漠的流沙术士，以岩元素结晶造成范围伤害，适合作为队伍的地面输出核心。",
    popularity: 86,
    releaseDate: "2025-12-08",
    stats: {
      "基础生命": "11,980",
      "基础攻击": "326",
      "基础防御": "716",
      "最佳武器": "图莱杜拉的回忆",
      "核心命座": "二命 / 六命",
    },
    talents: [
      { name: "普通攻击·沙砾", type: "普通攻击", desc: "操控沙粒进行攻击，重击造成范围岩元素伤害。" },
      { name: "元素战技·流沙漩涡", type: "元素战技", desc: "在地面生成沙漩涡，持续吸附并造成岩元素伤害，冷却 12 秒。" },
      { name: "元素爆发·沙暴降临", type: "元素爆发", desc: "召唤巨型沙暴，对范围内敌人造成多段岩元素伤害。" },
      { name: "固有天赋·砂之壁", type: "固有天赋", desc: "处于沙漩涡范围内的角色获得护盾，受到的伤害降低 12%。" },
    ],
    teamComp: ["砂卷 + 磐岩 + 荆藤 + 班尼特", "砂卷 + 岚心 + 蒹葭 + 钟离"],
    playTips: [
      "元素战技的吸附效果可以帮助队伍集中输出。",
      "岩元素无法触发元素反应，更依赖自身面板与增伤辅助。",
      "护盾效果可与岩系角色护盾叠加，提升生存能力。",
    ],
  },
  {
    id: "lumenbell",
    name: "铃兰",
    title: "月华歌者",
    element: "anemo",
    elementName: "风",
    role: "support",
    roleName: "辅助",
    rarity: 4,
    weapon: "法器",
    region: "璃月",
    avatar: "https://readdy.ai/api/search-image?query=anime%20style%20gentle%20female%20singer%20portrait%20with%20silver%20hair%20and%20bell%20accessory%2C%20soft%20mint%20background%20with%20note%20and%20wind%20motifs%2C%20clean%20character%20art%2C%20painterly%20fantasy%20style&width=500&height=500&seq=char-avatar-lumenbell&orientation=squarish",
    splash: "https://readdy.ai/api/search-image?query=anime%20style%20full%20body%20female%20singer%20surrounded%20by%20floating%20musical%20notes%20and%20wind%2C%20graceful%20pose%2C%20soft%20mint%20gradient%20background%2C%20detailed%20character%20illustration%2C%20painterly%20fantasy%20style&width=900&height=1200&seq=char-splash-lumenbell&orientation=portrait",
    intro: "璃月的月华歌者，以歌声为队伍提供治疗与增益，是优秀的四星风系辅助。",
    popularity: 78,
    releaseDate: "2025-11-11",
    stats: {
      "基础生命": "11,200",
      "基础攻击": "218",
      "基础防御": "612",
      "最佳武器": "西风秘典",
      "核心命座": "三命 / 五命",
    },
    talents: [
      { name: "普通攻击·铃音", type: "普通攻击", desc: "以音符进行攻击，重击造成范围风元素伤害。" },
      { name: "元素战技·月华之音", type: "元素战技", desc: "为队伍提供持续治疗并提升移动速度，冷却 10 秒。" },
      { name: "元素爆发·风之歌", type: "元素爆发", desc: "为全队提供大范围治疗并提升攻击力，持续 12 秒。" },
      { name: "固有天赋·铃兰庇护", type: "固有天赋", desc: "治疗量基于生命值上限提升，且为队友提供风元素抗性。" },
    ],
    teamComp: ["铃兰 + 烬珞 + 香菱 + 岚心", "铃兰 + 任意主输出 + 双辅助"],
    playTips: [
      "堆生命值即可兼顾治疗量与输出增益。",
      "移动速度增益在探索地图时非常实用。",
      "适合作为新手期的泛用治疗角色。",
    ],
  },
];